import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import {
	/*API_URL,*/ API2_URL, MUNICIPALITIES_FAIL, MUNICIPALITIES_SHOW, MUNICIPALITIES_FETCH, MUNICIPALITIES_EDIT,
	MUNICIPALITIES_REQUEST, MUNICIPALITIES_FILTERED
} from "../store/config";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export const municipalitiesShow = (page = 1, filters={}) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				dispatch(municipalitiesRequest());

				return fetch(`${API2_URL}/municipalities?include[0]=state&include[1]=modality&page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(municipalitiesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(municipalitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
};

export const municipalitiesList = (entity, filter = false) => {
	/*
	* Guarda las entidades en la sesion, para no mandarla a pedir al servidor, cada vez que se necesite.
	* */
    /*let storage = sessionStorage.getItem("etrans_municipalities_"+entity);

    if (storage === null) {

    }
    else{
        storage=JSON.parse(storage);
        return dispatch => {
            filter === true ? dispatch(municipalitiesFilteredRequest()) : dispatch(municipalitiesRequest());
            if (filter === true) {
                dispatch(municipalitiesFilteredData(storage,entity))
            } else {
                dispatch(municipalitiesAllData(storage,entity))
            }
        }
	}*/
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				filter === true ? dispatch(municipalitiesFilteredRequest()) : dispatch(municipalitiesRequest());
				return fetch(`${API2_URL}/municipalities?state_id=${entity}&order_by[field]=name&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							if (filter === true) {
								dispatch(municipalitiesFilteredData(json,entity))
							} else {
								dispatch(municipalitiesAllData(json,entity))
							}
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(municipalitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const municipalityEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(municipalitiesRequest());

				return fetch(`${API2_URL}/municipalities/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(municipalityEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(municipalitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const municipalitySave = (formData) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(formData)
				};

				dispatch(municipalitiesRequest());
				return fetch(`${API2_URL}/municipalities${formData.id ? `/${formData.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"El municipio se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(formData.id)){
								history.push(`/municipios/editar/${json.data.id}`);
							}
							return dispatch(municipalityEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(municipalitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const municipalityDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				dispatch(municipalitiesRequest());
				return fetch(`${API2_URL}/municipalities/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Esto no es un simulacro", content: json.message ? json.message:`Se eliminó el siguiente municipio: <strong>${json.name}</strong>`, type: "warning"}));
							dispatch(municipalitiesShow());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(municipalitiesFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

const municipalitiesRequest = () => {
	return {
		type: MUNICIPALITIES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const municipalitiesFailed = (error) => {
	return {
		type: MUNICIPALITIES_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}

const municipalitiesAllData = (json,entity) => {
    //sessionStorage.setItem("etrans_municipalities_"+entity,JSON.stringify(json));
	return {
		type: MUNICIPALITIES_FETCH,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}

const municipalitiesFilteredData = (json,entity) => {
    //sessionStorage.setItem("etrans_municipalities_"+entity,JSON.stringify(json));
	return {
		type: MUNICIPALITIES_FILTERED,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}

const municipalitiesFilteredRequest = () => {
	return {
		type: MUNICIPALITIES_FILTERED,
		isFetching: true,
		payload: [],
		timestamp: Date.now()
	}
}

const municipalitiesData = (json) => {
	return {
		type: MUNICIPALITIES_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const municipalityEditData = (json) => {
	return {
		type: MUNICIPALITIES_EDIT,
		isFetching: false,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/municipalities.js